<template>
  <div class="uikit_button">
    <uikit-icon :name="icon"/>
    <h4>{{title}}</h4>
  </div>
</template>

<script>
import UikitIcon from "./component.uikit.icon.vue";

export default {
  name: "uikitButton",
  components:{
    UikitIcon
  },
  props: {
    title:{
      type: String,
      default: "Button"
    },
    icon:{
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.uikit_button {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: .375rem;
  border: 1px solid hsla(0,0%,100%,.2);
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all .25s;
  gap: 8px;
}
.uikit_button:hover{
  background: hsla(240,9%,59%,.1)
}
</style>
